import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';

export default function ReviewPage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = `${t('reviewH1')} | CSSBuy Spreadsheet`;
  }, [t]);

  const pros = [
    t('reviewPro1'),
    t('reviewPro2'),
    t('reviewPro3'),
    t('reviewPro4'),
  ];

  const cons = [
    t('reviewCon1'),
    t('reviewCon2'),
    t('reviewCon3'),
    t('reviewCon4'),
  ];

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <div className="max-w-6xl mx-auto px-4 md:px-6 pt-24 pb-4">
          <nav className="flex items-center gap-2 text-sm text-foreground-500">
            <Link to="/" className="hover:text-primary-600 transition-colors">{t('breadcrumbHome')}</Link>
            <i className="ri-arrow-right-s-line" style={{ width: 16, height: 16 }} />
            <span className="text-foreground-700">{t('breadcrumbReview')}</span>
          </nav>
        </div>

        <section className="py-8 md:py-12">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <h1 className="font-heading text-3xl md:text-5xl text-foreground-950 mb-6">
              {t('reviewH1')}
            </h1>
            <p className="text-lg text-foreground-700 leading-relaxed mb-10 max-w-3xl">
              {t('reviewIntro')}
            </p>

            <div className="grid md:grid-cols-2 gap-6 md:gap-8 mb-10">
              <div className="bg-background-100 rounded-2xl p-6 md:p-8">
                <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-4 flex items-center gap-2">
                  <i className="ri-thumb-up-line text-accent-600" style={{ width: 20, height: 20 }} />
                  {t('reviewPros')}
                </h2>
                <ul className="space-y-3">
                  {pros.map((pro, index) => (
                    <li key={index} className="flex items-start gap-2 text-sm text-foreground-700">
                      <i className="ri-check-line text-accent-600 mt-0.5 flex-shrink-0" style={{ width: 16, height: 16 }} />
                      <span>{pro}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="bg-background-100 rounded-2xl p-6 md:p-8">
                <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-4 flex items-center gap-2">
                  <i className="ri-error-warning-line text-primary-500" style={{ width: 20, height: 20 }} />
                  {t('reviewCons')}
                </h2>
                <ul className="space-y-3">
                  {cons.map((con, index) => (
                    <li key={index} className="flex items-start gap-2 text-sm text-foreground-700">
                      <i className="ri-alert-line text-primary-500 mt-0.5 flex-shrink-0" style={{ width: 16, height: 16 }} />
                      <span>{con}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="mt-10 pt-8 border-t border-background-200/70">
              <h3 className="font-semibold text-foreground-950 mb-4">{t('articleRelated')}</h3>
              <div className="flex flex-wrap gap-3">
                <Link to="/cssbuy-spreadsheet" className="px-4 py-2 bg-background-100 rounded-lg text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors">{t('breadcrumbSpreadsheet')}</Link>
                <Link to="/cssbuy-shipping" className="px-4 py-2 bg-background-100 rounded-lg text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors">{t('navShipping')}</Link>
                <Link to="/cssbuy-guide" className="px-4 py-2 bg-background-100 rounded-lg text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors">{t('navGuide')}</Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}